import Vue from 'vue'
import VueRouter from 'vue-router'
import { routes } from "./routes"
import { checkAccessMiddleware } from "./middlewares"

Vue.use(VueRouter)

const router = new VueRouter({
  mode:  process.env.CORDOVA_PLATFORM ? 'hash' :'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach(checkAccessMiddleware)

export default router
